module.exports = __webpack_public_path__ + "static/Kroger_pin-7bc83819fdf97cd8eb1bb96cf3fce779.png";